module.exports = __webpack_public_path__ + "img/38.385b6851.jpg";